export const appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#2A1B47',
    colorBackground: '#FFFFFF',
    colorText: '#15151E',
    colorDanger: '#df1b41',
    fontFamily: '"Titillium Web", sans-serif',
    spacingUnit: '4px',
    borderRadius: '3px',
    colorSuccess: 'green',
    spacingAccordionItem: '500px'
  },
  rules: {
    '.AccordionItem': {
      backgroundColor: 'transparent',
      border: '1px solid transparent',
      boxShadow: 'none',
    },
    '.Input': {
      backgroundColor: 'rgba(205, 191, 227, 0.1)',
      boxShadow: 'none',
      border: '1px solid #CDBFE3',
      borderRadius: '3px',
      padding: '13px 15px',
      fontSize: '14px',
      lineHeight: '20px',
    },
    '.Label': {
      fontFamily: '"Titillium Web", sans-serif',
      fontSize: '14px',
      fontWeight: '700',
      color: '#15151E'
    },
    '.PickerItem': {
      fontFamily: '"Titillium Web", sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      color: '#15151E'
    },
  }
}

export const fonts = [
  {
    cssSrc: 'https://fonts.googleapis.com/css?family=Titillium+Web:400,700',
  }
]
